export function getThumbnailFromVideo(videoUrl) {
  // We use Cloudflare transform to pull the first frame of the video as a thumbnail.
  return `https://media.stackinfluence.com/cdn-cgi/media/mode=frame,width=250,height=250,fit=cover/${videoUrl}`;
}

export function getThumbnailForImage(imageUrl) {
  // We use Cloudflare transform to resize the image to 250x250
  // (larger than rendered size of thumbnail, but avoids pixelation)
  return `https://media.stackinfluence.com/cdn-cgi/image/width=250,height=250,fit=contain/${imageUrl}`;
}
